module.exports = __webpack_public_path__ + "img/arrow-prev.6e2507ba.svg";